import * as cons from './constants';

const actionUiMaker = (action) => ({ ...action, type: action.cons.REQUEST_UPDATE });

export const resetErrors = option => (actionUiMaker({ cons: cons.RESET_ERRORS, ...option }));
